<template>
<div class="meter-apportion" ref="meterApportion">
  <div class="meter-apportion-tree" ref="meterApportionTree">
    <MeterTreeComponent :project_id="project_id" ref="MeterTreeComponentRef" :width="leftWidth" height="calc(100vh - 200px)" @onClick="onClickMeter" />
<!--    <MeterTreeEditorComponent :project_id="project_id" ref="MeterTreeComponentRef" :width="leftWidth" height="calc(100vh - 200px)" @onClick="onClickMeter" />-->
  </div>
  <div class="resize" title="左右侧边栏" ref="resize">⋮</div>
  <div class="meter-apportion-list" ref="meterApportionList">
    <div>
      <div style="margin-bottom: 10px;">
        <el-button size="mini" type="primary" @click="reGetData">刷新</el-button>
        <el-button size="mini" type="primary" @click="getAllData">重新获取全部</el-button>
        <el-button size="mini" type="primary" @click="settingData" v-if="user_type === 2">设置分摊模式</el-button>
        <el-button size="mini" type="primary" @click="initMeterApportion">重置模式</el-button>
        <el-button size="mini" type="primary" @click="exportMeterApportion">导出</el-button>
        <el-button size="mini" type="primary" @click="importMeterApportion">导入</el-button>
        <el-dropdown @command="handleCommand">
          <el-button size="mini" type="primary">
            更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="setMeterApportionWuye">{{user_type === 2? '设置物业能耗' : '设置业主能耗'}}</el-dropdown-item>
            <el-dropdown-item command="setMeterApportionXs">设置承担损耗</el-dropdown-item>
            <el-dropdown-item command="setMeterApportionType">设置分摊类型</el-dropdown-item>

          </el-dropdown-menu>
        </el-dropdown>
<!--        <el-button size="mini" @click="setMeterApportionWuye">设置物业能耗</el-button>-->
<!--        <el-button size="mini" @click="setMeterApportionXs">设置承担损耗</el-button>-->
<!--        <el-button size="mini" @click="setMeterApportionType">设置分摊类型</el-button>-->
      </div>
      <div>
        <el-select v-model="where.meter_level" placeholder="等级" @change="pageChange(1)" style="width: 150px;" size="mini">
          <el-option label="全部" :value="0"></el-option>
          <el-option label="一级" :value="1"></el-option>
          <el-option label="二级" :value="2"></el-option>
          <el-option label="三级" :value="3"></el-option>
          <el-option label="四级" :value="4"></el-option>
        </el-select>
        <el-select v-model="where.energy" placeholder="能耗类型" @change="pageChange(1)" style="width: 150px;" size="mini">
          <el-option label="全部" :value="0"></el-option>
          <el-option label="业主能耗" :value="1"></el-option>
          <el-option label="物业能耗" :value="2"></el-option>
          <el-option label="分摊能耗" :value="3"></el-option>
        </el-select>
        <el-select v-model="where.apportion_type" placeholder="分摊模式" @change="pageChange(1)" style="width: 150px;" size="mini">
          <el-option v-for="(item,index) in apportion_type_list" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
<!--        <el-input v-model="where.ancestor_name" placeholder="房产名称" @change="pageChange(1)" style="width: 200px;" size="mini"></el-input>-->
        <el-input v-model="where.number" placeholder="仪表编号" @change="pageChange(1)" style="width: 150px;" size="mini"></el-input>
        <el-input v-model="where.name" placeholder="仪表名称" @change="pageChange(1)" style="width: 150px;" size="mini"></el-input>
      </div>
<!--      <div class="header-tip">-->
<!--        <el-link type="primary" style="color: #FFFFFF;" @click="isSetType(0)">仪表数：{{meter_count}}</el-link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
<!--        <el-link type="primary" style="color: #FFFFFF;" @click="isSetType(1)">已设置：{{setting_count}}</el-link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
<!--        <el-link type="primary" style="color: #FFFFFF;" @click="isSetType(2)">未设置：{{not_setting_count}}</el-link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
<!--      </div>-->
      <div class="header-tip">
        <el-link type="primary" style="color: #FFFFFF;" @click="isSetType(0)">仪表数：{{statisticsObj.all_count}}</el-link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-link type="primary" style="color: #FFFFFF;" @click="isSetType(1)">已设置：{{statisticsObj.has_apportion_count}}</el-link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-link type="primary" style="color: #FFFFFF;" @click="isSetType(2)">未设置：{{statisticsObj.no_apportion_count}}</el-link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="pageData.list"
      border height="calc(100vh - 350px)" width="99%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column
        prop="number"
        label="仪表编号"
        width="120" fixed>
<!--        <template slot-scope="scope">-->
<!--          <el-link type="primary">{{scope.row.number}}</el-link>-->
<!--        </template>-->
      </el-table-column>
      <el-table-column
        prop="name"
        label="仪表名称"
        width="200">
      </el-table-column>
      <el-table-column
        prop="apportion_type_name"
        label="分摊模式"
        width="100">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.apportion_type_name">{{scope.row.apportion_type_name}}</el-link>
          <el-link type="danger" v-else>未设置</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="energy"
        label="能耗类型"
        width="100">
        <template slot-scope="scope">
          {{meterEnergyName(scope.row.energy)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="meter_level"
        label="等级"
        width="60">
        <template slot-scope="scope">
          <el-link type="primary">{{meterLevelName(scope.row.meter_level)}}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="children_count"
        label="下级数量"
        width="70">
      </el-table-column>
      <el-table-column
        prop="ancestor_name"
        min-width="200"
        label="房产">
      </el-table-column>
      <el-table-column
        label="操作" width="200px" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" icon="el-icon-edit" @click="updateEdit(scope.row)">设置</el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="oneInitMeterApportion(scope.row.id)">初始化</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px;text-align: center;display: flex;justify-content: center;align-items: center;">
      <el-input v-model="pageData.pageSize" placeholder="每页显示条数" @change="pageChange(1)" style="width: 80px;" size="mini"></el-input>
      <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
    </div>
  </div>
  <ApportionWin ref="ApportionWinRef" />
  <SelectApportionWin ref="SelectApportionWinRef" />
  <ErpConfirm ref="ErpConfirmRef" />
</div>
</template>

<script>
import ApportionWin from "./components/apportion/ApportionWin";
// let meter_list=[];
// let pages_meter_list=[];
let meter_tree=[];
import MeterTreeComponent from "./components/MeterTreeComponent";
import SelectApportionWin from "./components/SelectApportionWin";
import MeterTreeEditorComponent from "./components/MeterTreeEditorComponent";
import ErpConfirm from "../../../Common/ErpConfirm";
import Http from "../../common/Http";
import MeterHttp from "../../common/MeterHttp";
export default {
  name: "MeterApportion",
  components: {ErpConfirm, SelectApportionWin, ApportionWin, MeterTreeComponent,MeterTreeEditorComponent},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      meter_list:[],
      pages_meter_list:[],
      pageData: {
        list: [],
        total: 0,
        pageSize: 30,
        page: 1
      },
      where:{
        meter_level:0,
        energy:0,
        apportion_type:'',
        ancestor_name:'',
        number:'',
        name:'',
        is_set:0,
      },
      loading:false,
      multipleSelection:[],
      apportion_type_obj: {
        average: "平均分摊",
        area: "面积分摊",
        usage: "用量分摊",
        floor: "楼层分摊",
        currency: "通用分摊"
      },
      apportion_type_list: [
        {
          value: "average",
          label: "平均分摊"
        },
        {
          value: "area",
          label: "面积分摊"
        },
        {
          value: "usage",
          label: "用量分摊"
        },
        {
          value: "floor",
          label: "楼层分摊"
        },
        {
          value: "currency",
          label: "通用分摊"
        }
      ],
      leftWidth: '250px',
      statisticsObj:{
        all_count:0,
        no_apportion_count:0,
        has_apportion_count:0
      },
      p_meter_id:0,
    }
  },
  mounted(){
    const that=this;
    that.dragControllerLR({
      resize:that.$refs.resize,
      iframe:that.$refs.meterApportion,
      left:that.$refs.meterApportionTree,
      right:that.$refs.meterApportionList
    },({leftWidth})=>{
      that.leftWidth=leftWidth;
    });
  },
  methods:{
    onClickMeter(node){
      const that=this;
      // this.$emit("onClickMeter",node)
      meter_tree=node;
      // console.log(node)
      that.meter_list=[];
      that.meter_list.push({
        id: node.id,
        pid: node.pid,
        children_count: node.children_count,
        number: node.number,
        name: node.name,
        ancestor_name: node.ancestor_name,
        cdj_house_id: node.cdj_house_id,
        meter_name: node.meter_name,
        meter_level: node.meter_level,
        energy: node.energy,
        apportion_id: node.apportion_id,
        apportion_type: node.apportion_type,
        apportion_type_name: getApportionTypeName(node.apportion_type),
      })
      treeToList(node.children,that.meter_list);
      that.pages_meter_list=that.meter_list.filter(ret=>(ret.id===node.id||ret.pid===node.id))
      that.p_meter_id=node.id;
      that.pageChange(1);
    },
    pageChange(i=1){
      const that=this;
      that.loading=true;
      that.multipleSelection=[];
      that.pageData.page = i;
      let list=ERP.reJson(that.pages_meter_list);
      if(that.where.meter_level!==0) list=list.filter(ret=>ret.meter_level===that.where.meter_level)
      if(that.where.energy!==0) list=list.filter(ret=>ret.energy===that.where.energy)
      if(that.where.apportion_type!=='') list=list.filter(ret=>ret.apportion_type===that.where.apportion_type)
      if(that.where.ancestor_name!=='') list=list.filter(ret=>ret.ancestor_name.indexOf(that.where.ancestor_name)>-1)
      if(that.where.number!=='') list=list.filter(ret=>ret.number.indexOf(that.where.number)>-1)
      if(that.where.name!=='') list=list.filter(ret=>ret.name.indexOf(that.where.name)>-1)
      if(that.where.is_set!==0){
        if(that.where.is_set===1){
          list=list.filter(ret=>!!ret.apportion_type_name)
        }else {
          list=list.filter(ret=>!ret.apportion_type_name)
        }
      }
      that.pageData.total = list.length;
      that.pageData.list=list.splice((that.pageData.page-1)*that.pageData.pageSize,that.pageData.pageSize);
      that.loading=false;
      that.getSettingCount()
    },
    isSetType(i){
      this.where.is_set=i;
      this.pageChange(1)
    },
    updateEdit(model){
      const that=this;
      // console.log(item)
      that.$refs.ApportionWinRef.show({id:model.id,name:model.name,number:model.number})
    },
    reGetData(){
      const that=this;
      that.$refs.MeterTreeComponentRef.getData(list=>{
        that.meter_list=[];
        list.map(node=>{
          that.meter_list.push({
            id: node.id,
            pid: node.pid,
            children_count: node.children_count,
            number: node.number,
            name: node.name,
            ancestor_name: node.ancestor_name,
            cdj_house_id: node.cdj_house_id,
            meter_name: node.meter_name,
            meter_level: node.meter_level,
            energy: node.energy,
            apportion_id: node.apportion_id,
            apportion_type: node.apportion_type,
            apportion_type_name: getApportionTypeName(node.apportion_type),
          })
        })
        that.pages_meter_list=that.meter_list.filter(ret=>(ret.id===meter_tree.id||ret.pid===meter_tree.id))
        that.pageChange(1)
      })
    },
    getAllData(){
      const that=this;
      that.$refs.MeterTreeComponentRef.getData(list=>{
        that.meter_list=[];
        list.map(node=>{
          that.meter_list.push({
            id: node.id,
            pid: node.pid,
            children_count: node.children_count,
            number: node.number,
            name: node.name,
            ancestor_name: node.ancestor_name,
            cdj_house_id: node.cdj_house_id,
            meter_name: node.meter_name,
            meter_level: node.meter_level,
            energy: node.energy,
            apportion_id: node.apportion_id,
            apportion_type: node.apportion_type,
            apportion_type_name: getApportionTypeName(node.apportion_type),
          })
        })
        that.pages_meter_list=that.meter_list;
        that.pageChange(1)
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    settingData(){
      const that=this;
      if(that.multipleSelection.length===0){
        that.$message.error('请选择仪表再批量设置');
        return false;
      }
      that.$refs.SelectApportionWinRef.show({
        project_id:that.project_id,
        meter_list:that.multipleSelection,
        callback:()=>{
          that.reGetData();
        }
      })
    },
    meterLevelName(meter_level){
      let level_obj={
        1:"一级",
        2:"二级",
        3:"三级",
        4:"四级",
      };
      return level_obj[meter_level]||"";
    },
    meterEnergyName(energy){
      let energy_obj={
        1:"业主能耗",
        2:"物业能耗",
        3:"分摊能耗",
      };
      return energy_obj[energy]||"";
    },
    dragControllerLR({resize,iframe, left, right},callback) {
      const that=this;
     resize.onmousedown = function (e) {
        //颜色改变提醒
        resize.style.background = "#818181";
        let startX = e.clientX;
        resize.left = resize.offsetLeft;
        // 鼠标拖动事件
        document.onmousemove = function (e) {
          let endX = e.clientX;
          let moveLen = resize.left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
          let maxT = iframe.clientWidth - resize.offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

          if (moveLen < 50) moveLen = 50; // 左边区域的最小宽度为50px
          if (moveLen > maxT - 150) moveLen = maxT - 150; //右边区域最小宽度为150px

          resize.style.left = moveLen; // 设置左侧区域的宽度

          typeof callback=== "function" && callback({
            moveLen: moveLen,
            maxT: maxT,
            leftWidth: (moveLen-5) + "px",
            rightWidth: iframe.clientWidth - moveLen - 10 + "px"
          });

          left.style.width = moveLen + "px";
          right.style.width = iframe.clientWidth - moveLen - 10 + "px";

        };
        // 鼠标松开事件
        // eslint-disable-next-line no-unused-vars
        document.onmouseup = function (evt) {
          //颜色恢复
          resize.style.background = "#d6d6d6";
          document.onmousemove = null;
          document.onmouseup = null;
          resize.releaseCapture && resize.releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
        };
        resize.setCapture && resize.setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
        return false;
      };
    },
    oneInitMeterApportion(meter_id){
      const that=this;
      if(!meter_id){
        that.$message.error('请选择仪表再批量重置');
        return false;
      }
      that.$confirm('确认要重置所选仪表分摊模式吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading = true;
        MeterHttp.post('MeterApportion/deleteMeterApportion?user_type='+that.$route.query.type,{
          project_id: that.project_id,
          meter_ids: meter_id,
        }, res => {
          that.loading = false;
          that.$message.success('批量重置成功');
          that.reGetData();
        })
      }).catch(() => {
        that.loading = false;
        that.$message.error('取消批量重置');
      });
    },
    initMeterApportion(){
      const that=this;
      if(that.multipleSelection.length===0){
        that.$message.error('请选择仪表再批量重置');
        return false;
      }
      that.$confirm('确认要批量重置所选仪表分摊模式吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading = true;
        MeterHttp.post('MeterApportion/deleteMeterApportion?user_type='+that.$route.query.type,{
          project_id: that.project_id,
          meter_ids: that.multipleSelection.map(ret=>ret.id).join(','),
        }, res => {
          that.loading = false;
          that.$message.success('批量重置成功');
          that.reGetData();
        })
      }).catch(() => {
        that.loading = false;
        that.$message.error('取消批量重置');
      });
    },
    setMeterApportionWuye(){
      const that=this;
      if(that.multipleSelection.length===0) {
        that.$message.error('请选择仪表再批量设置');
        return false;
      }
      that.$confirm('确认要批量设置所选物业能耗仪表的分摊模式吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading = true;
        MeterHttp.post('MeterApportion/setMeterApportionWuye?user_type='+that.$route.query.type,{
          project_id: that.project_id,
          meter_ids: that.multipleSelection.map(ret=>ret.id).join(','),
        }, res => {
          that.loading = false;
          that.$message.success('批量成功');
          that.reGetData();
        })
      }).catch(() => {
        that.loading = false;
        that.$message.error('取消批量设置');
      });
    },
    setMeterApportionXs(){
      const that=this;
      if(that.multipleSelection.length===0) {
        that.$message.error('请选择仪表再批量设置');
        return false;
      }
      that.$refs.ErpConfirmRef.show({
        title:'设置损耗承担',
        content:'确认要批量设置所选仪表的损耗承担模式吗？',
        button_list:[{name:"承担",type:"primary",value:1},{name:"不承担",type:"primary",value:2}]
      },item=>{
        that.loading = true;
        MeterHttp.post('MeterApportion/setMeterApportionIdsToKeyValue?user_type='+that.$route.query.type,{
          project_id: that.project_id,
          key:"is_line_loss",
          value:item.value==1?1:0,
          meter_ids: that.multipleSelection.map(ret=>ret.id).join(','),
        }, res => {
          that.loading = false;
          that.$message.success('批量成功');
          that.reGetData();
        })
      })
    },
    setMeterApportionType(){
      const that=this;
      if(that.multipleSelection.length===0) {
        that.$message.error('请选择仪表再批量设置');
        return false;
      }
      that.$refs.ErpConfirmRef.show({
        title:'设置分摊类型',
        content:'确认要批量设置所选仪表的分摊类型吗？',
        button_list:[{name:"用量",type:"primary",value:1},{name:"线损",type:"primary",value:2},{name:"用量+线损",type:"primary",value:3}]
      },item=>{
        that.loading = true;
        MeterHttp.post('MeterApportion/setMeterApportionIdsToKeyValue?user_type='+that.$route.query.type,{
          project_id: that.project_id,
          key:"apportion_tip",
          value:item.value,
          meter_ids: that.multipleSelection.map(ret=>ret.id).join(','),
        }, res => {
          that.loading = false;
          that.$message.success('批量成功');
          that.reGetData();
        })
      })
    },
    getSettingCount(){
      const that=this;
      MeterHttp.post('MeterApportion/getStatisticsCount?user_type='+that.$route.query.type,{
        project_id: that.project_id,
        meter_id: that.p_meter_id,
      }, res => {
        if(res.code){
          that.statisticsObj = res.data;
        }
      })
    },
    exportMeterApportion(){
      const that=this;
      // if(that.multipleSelection.length===0) {
      //   that.$message.error('请选择仪表再导出');
      //   return false;
      // }
      let ids=that.multipleSelection.map(ret=>ret.meter_id).join(',');
      MeterHttp.post('MeterApportion/exportMeterApportion?user_type='+that.$route.query.type,{
        project_id: that.project_id,
        meter_ids: ids,
      }, res => {
        if(res.code){
          that.$message.success('导出成功');
          if(res.data.indexOf("http")===-1){
            window.open(__HTTP__.defaults.baseURL +res.data)
          }else {
            window.open(res.data)
          }
        }else{
          that.$message.error('导出失败');
        }
      })
    },
    importMeterApportion(){
      const that=this;
      MeterHttp.uploadFile(file=>{
        MeterHttp.post('MeterApportion/importMeterApportion?user_type='+that.$route.query.type,{
          file: file,
        }, res => {
          if(res.code){
            that.$message.success('导入成功');
            console.log(res.data);
          }else{
            that.$message.error('导入成功');
          }
        });
      })
    },
    handleCommand(command){
      const that=this;
      switch (command) {
        case "setMeterApportionWuye":
          that.setMeterApportionWuye();
          break;
        case "setMeterApportionXs":
          that.setMeterApportionXs();
          break;
        case "setMeterApportionType":
          that.setMeterApportionType();
          break;
        default:
          break;
      }
    },

  },
  computed:{
    setting_count(){
      return this.meter_list.filter(ret=>!!ret.apportion_id).length
    },
    meter_count(){
      return this.meter_list.length
    },
    not_setting_count(){
      return this.meter_count-this.setting_count;
    },
    project_id(){
      return this.mainObj.project_id
    },
    user_type(){
      return this.$route.query.type*1
    }
  },
  watch:{
    project_id(n,o){
      const that=this;
      if(n){
        setTimeout(function () {
          that.reGetData();
        },500);
      }
    }
  }
}
const treeToList = (_children_list=[],_meter_list=[]) => {
  if(_children_list.length){
    _children_list.map(ret=>{
      _meter_list.push({
        id: ret.id,
        pid: ret.pid,
        children_count: ret.children_count,
        number: ret.number,
        name: ret.name,
        ancestor_name: ret.ancestor_name,
        cdj_house_id: ret.cdj_house_id,
        meter_name: ret.meter_name,
        meter_level: ret.meter_level,
        energy: ret.energy,
        apportion_id: ret.apportion_id,
        apportion_type: ret.apportion_type,
        apportion_type_name: getApportionTypeName(ret.apportion_type),
      })
      treeToList(ret.children,_meter_list);
    })
  }
}
const getApportionTypeName = (apportion_type) => {
  let apportion_type_obj={
    average:"平均分摊",
    area:"面积分摊",
    usage:"用量分摊",
    floor:"楼层分摊",
    currency:"通用分摊"
  }
  return apportion_type_obj[apportion_type]||""
}
</script>

<style lang="scss" scoped>
@import "../../common";
.meter-apportion{
  display: flex;
  flex-direction: row;
  .meter-apportion-tree{

  }
  .meter-apportion-list{
    width: calc(100% - 260px);
  }
}
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}

/* 拖拽区div样式 */
.resize {
  cursor: w-resize;
  float: left;
  position: relative;
  top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  width: 10px;
  height: 50px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 32px;
  color: white;
  margin:auto 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/MeterApportion.vue